<div *ngIf="mappedData" class="license-panel">
  <div class="license-panel__container">
    <license-card-item *ngFor="let item of mappedData" [data]="item" #cardItem></license-card-item>
  </div>
</div>
